import { render, staticRenderFns } from "./SwipeItemC.vue?vue&type=template&id=53270c6f&scoped=true&"
import script from "./SwipeItemC.vue?vue&type=script&lang=js&"
export * from "./SwipeItemC.vue?vue&type=script&lang=js&"
import style0 from "./SwipeItemC.vue?vue&type=style&index=0&id=53270c6f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53270c6f",
  null
  
)

export default component.exports